import { BrandingConfig } from '../../api/app-types/branding-config.app';

export const DEFAULT_BRANDING: BrandingConfig = {
	logo: '/image/logoipsum.png',
	favicon: '/favicons/.ico',
};

export const BRANDINGS: Record<string, BrandingConfig> = {
	//TODO: Add Logos and favicons, name could be changed, depends on BE
	lvr: {
		logo: '/image/lvr-logo.svg',
		favicon: '/favicons/lvr-favicon.jpg',
	},
	bre: {
		logo: '/image/bre-logo.svg',
		favicon: '/favicons/bre-favicon.ico',
	},
	thue: {
		logo: '/image/thue-logo.jpg',
		favicon: '/favicons/thue-favicon.jpg',
	},
	//SAARLAND
	sa: {
		logo: '',
		favicon: '',
	},
	lwl: {
		logo: '/image/lwl-logo.png',
		favicon: '/favicons/LWL-favicon.png',
	},
	// Niedersachsen
	nds: {
		logo: '',
		favicon: '/favicons/nds-favicon.ico',
	},
	//SACHSENANHALT
	saa: {
		logo: '/image/saa-logo.png',
		favicon: '/favicons/saa-favicon.png',
	},
};
